import { minBreakpoints, primarySemiBoldFont, responsiveFontSize, theme } from '@noths/polaris-client-ribbons-base';
import { inset, mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing,
  text = theme.text;
var titleSizes = {
  XXS: text.BODY.SM,
  L: text.BODY.MD
};
export var grid = /*#__PURE__*/css(["grid-row-gap:", ";"], pxToRem(spacing.sm));
export var gridItem = /*#__PURE__*/css(["grid-column:span 6;overflow:hidden;border-radius:", ";"], pxToRem(10));
export var gridItemFourLayout = /*#__PURE__*/css(["", ""], mediaQuery({
  min: minBreakpoints.M
}, css(["grid-column:span 3;"])));
export var link = /*#__PURE__*/css(["text-decoration:none;color:inherit;&:hover{box-shadow:0 ", " ", " 0 rgba(0,0,0,0.2);}"], pxToRem(-2), pxToRem(4));
export var title = /*#__PURE__*/css(["display:flex;justify-content:center;align-items:center;margin:0;padding:", ";text-align:center;height:", ";", ";", " background-color:var(--backgroundColor,var(--neutral-black-10));", ""], inset(spacing.xs, 0), pxToRem(52), primarySemiBoldFont, responsiveFontSize(titleSizes), mediaQuery({
  min: minBreakpoints.L
}, css(["height:", ";"], pxToRem(56))));
export var image = /*#__PURE__*/css(["display:block;width:100%;height:auto;"]);